(function () {
  const rootSelector = '[data-metta-mix]';
  const choiceSelector = '[data-metta-choice]';
  const minimumQuantity = 2;

  function getProductForm(container) {
    const formId = container.dataset.formId;
    if (formId) {
      const form = document.getElementById(formId);
      if (form) return form;
    }

    return container.closest('form') || container.closest('product-info')?.querySelector('form[is="product-form"]');
  }

  function getQuantityInput(form) {
    return form?.querySelector('input[name="quantity"]') || null;
  }

  function setQuantityForSameFlavor(form) {
    const quantityInput = getQuantityInput(form);
    if (!quantityInput) return;

    quantityInput.min = String(minimumQuantity);
    quantityInput.dataset.min = String(minimumQuantity);
    if (Number(quantityInput.value || 0) < minimumQuantity) {
      quantityInput.value = String(minimumQuantity);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setQuantityForMixedFlavor(form) {
    const quantityInput = getQuantityInput(form);
    if (!quantityInput) return;

    quantityInput.min = '1';
    quantityInput.dataset.min = '1';
    quantityInput.value = '1';
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateState(container, selectedChoice) {
    const hiddenInput = container.querySelector('[data-metta-secondary-variant]');
    const status = container.querySelector('[data-metta-status]');
    const form = getProductForm(container);
    const currentVariantId = form?.querySelector('[name="id"]')?.value || container.dataset.currentVariantId;
    const selectedVariantId = selectedChoice.dataset.mettaVariantId;
    const selectedTitle = selectedChoice.dataset.mettaProductTitle || '';
    const currentTitle = container.dataset.currentProductTitle || '';
    const isSameFlavor = selectedVariantId === currentVariantId;

    container.querySelectorAll(choiceSelector).forEach((choice) => {
      const isActive = choice === selectedChoice;
      choice.classList.toggle('is-active', isActive);
      choice.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (hiddenInput) hiddenInput.value = selectedVariantId;

    if (isSameFlavor) {
      setQuantityForSameFlavor(form);
      if (status) status.textContent = `Val 1: ${currentTitle}. Val 2: ${currentTitle}.`;
    } else {
      setQuantityForMixedFlavor(form);
      if (status) status.textContent = `Val 1: ${currentTitle}. Val 2: ${selectedTitle}.`;
    }
  }

  function initContainer(container) {
    if (container.dataset.mettaMixReady === 'true') return;
    container.dataset.mettaMixReady = 'true';

    const activeChoice = container.querySelector(`${choiceSelector}.is-active`) || container.querySelector(choiceSelector);
    if (activeChoice) updateState(container, activeChoice);
  }

  function init(root = document) {
    root.querySelectorAll(rootSelector).forEach(initContainer);
  }

  function getSectionsToBundle() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections },
      }),
    );

    return sections;
  }

  function setSubmitLoading(form, isLoading) {
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton) return;

    submitButton.classList.toggle('btn--loading', isLoading);
    if (isLoading) {
      submitButton.setAttribute('aria-disabled', 'true');
    } else {
      submitButton.removeAttribute('aria-disabled');
    }
  }

  function showFormError(form, message) {
    if (typeof form.displayFormErrors === 'function') {
      form.displayFormErrors(message);
      return;
    }

    const errorMessage = form.querySelector('.product-form__error-message');
    if (!errorMessage) {
      alert(message);
      return;
    }

    errorMessage.textContent = message;
    errorMessage.removeAttribute('hidden');
  }

  async function addMixedFlavors(form, container, currentVariantId, secondaryVariantId) {
    const currentTitle = container.dataset.currentProductTitle || 'vald smak';
    const selectedChoice = container.querySelector(`${choiceSelector}.is-active`);
    const secondaryTitle = selectedChoice?.dataset.mettaProductTitle || 'vald smak';
    const sections = getSectionsToBundle();
    const config = { ...FoxTheme.utils.fetchConfig('javascript') };

    config.body = JSON.stringify({
      items: [
        {
          id: Number(currentVariantId),
          quantity: 1,
          properties: {
            'MËTTA mix': secondaryTitle,
          },
        },
        {
          id: Number(secondaryVariantId),
          quantity: 1,
          properties: {
            'MËTTA mix': currentTitle,
          },
        },
      ],
      sections,
      sections_url: window.location.pathname,
    });

    setSubmitLoading(form, true);

    try {
      const response = await fetch(FoxTheme.routes.cart_add_url, config);
      const parsedState = await response.json();

      if (parsedState.status) {
        showFormError(form, parsedState.description || 'Kunde inte lägga produkterna i varukorgen.');
        return;
      }

      const cartResponse = await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig('json', 'GET') });
      const cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: parsedState,
          },
        }),
      );

      const cartDrawer = document.querySelector('cart-drawer');
      cartDrawer?.show(form.querySelector('[type="submit"]'));
    } catch (error) {
      console.error(error);
      showFormError(form, 'Kunde inte lägga produkterna i varukorgen. Försök igen.');
    } finally {
      setSubmitLoading(form, false);
    }
  }

  document.addEventListener('click', (event) => {
    const choice = event.target.closest(choiceSelector);
    if (!choice) return;

    const container = choice.closest(rootSelector);
    if (!container) return;

    updateState(container, choice);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const container = form.querySelector(rootSelector);
      if (!container) return;

      const currentVariantId = form.querySelector('[name="id"]')?.value;
      const secondaryVariantId = container.querySelector('[data-metta-secondary-variant]')?.value;

      if (!currentVariantId || !secondaryVariantId || currentVariantId === secondaryVariantId) {
        setQuantityForSameFlavor(form);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      addMixedFlavors(form, container, currentVariantId, secondaryVariantId);
    },
    true,
  );

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('variant:changed', () => init());
  init();
})();
